import { render, staticRenderFns } from "./SystemModulesDetail.vue?vue&type=template&id=04305fc6&scoped=true"
import script from "./SystemModulesDetail.vue?vue&type=script&lang=js"
export * from "./SystemModulesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04305fc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04305fc6')) {
      api.createRecord('04305fc6', component.options)
    } else {
      api.reload('04305fc6', component.options)
    }
    module.hot.accept("./SystemModulesDetail.vue?vue&type=template&id=04305fc6&scoped=true", function () {
      api.rerender('04305fc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/superadmin/systemmodule/SystemModulesDetail.vue"
export default component.exports